import { makeStyles } from '@material-ui/core/styles'

/**
 * define styles for the component
*/
export const AuthStyles = makeStyles((theme) => ({
  paper: {
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submitRegister: {
    color: '#FFFFFF',
    backgroundColor: theme.palette.secondary.dark,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    color: '#FFFFFF',
    backgroundColor: theme.palette.secondary.dark,
  },
  JustiLogo: {
    margin: theme.spacing(2),
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
  link: {
    color: theme.palette.secondary.dark,
  },
  description: {
    borderTop: '1px dotted #AAAAAA',
  },
  descriptionSpan: {
    background: 'white none repeat scroll 0 0',
    lineHeight: 0,
    padding: '0.1em 1.5em',
    position: 'relative',
  },
}))